module.exports = __webpack_public_path__ + "img/logo.2a8fd558.png";